import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import {
    Button,
    Checkbox,
    CircularProgress, Dialog, DialogContent, DialogTitle,
    IconButton,
    MenuItem,
    Select,
    Slider,
    TextField,
    Typography
} from "@mui/material";
import ApiCtrl from "../svc/ApiCtrl";

import VisibilityIcon from '@mui/icons-material/Visibility';
import SmsFailedIcon from '@mui/icons-material/SmsFailed';
import DoneIcon from '@mui/icons-material/Done';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import DeleteIcon from '@mui/icons-material/Delete';
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import useWindowDimensions from "../useWindowDimensions";
import MapBlaster from "./compo/MapBlaster";
import UploadDialog from "./compo/UploadDialog";
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
export default function MainView({setView}) {

    const {height, width} = useWindowDimensions();

    const [loading, setLoading] = React.useState(false);

    const [nbWorker, setNbWorker] = React.useState(1);
    const [maxNbWorker, setMaxNbWorker] = React.useState(10);
    const [threshold, setThreshold] = React.useState(3);
    const [maxThreshold, setMaxThreshold] = React.useState(3);
    const [minThreshold, setMinThreshold] = React.useState(1);
    const [length, setLength] = React.useState([50, 80]);
    const [maxLength, setMaxLength] = React.useState(365);
    const [minLength, setMinLength] = React.useState(1);


    const [listOfRegions, setListOfRegions] = React.useState(null);

    const [listOfMethods, setListOfMethods] = React.useState(null);

    const [listOfDate, setListOfDate] = React.useState(null);

    const [listOfQuery, setListOfQuery] = React.useState([]);

    const [tiles, setTiles] = React.useState(null);


    const columns = [
        {
            field: 'id', headerName: '', width: 180,
            valueGetter: (value, row) => {
                return row.id
            },
            renderCell: (value) => {
                let e = value.row.events.sort((a, b) => {
                    return a.time - b.time;
                });
                e = e.reverse()
                let vis = e[0].stepName === "done" || e[0].stepName === "end"
                return [
                    <IconButton
                        sx={{mr: 1}}
                        onClick={() => {
                            ApiCtrl.deleteSimulation(value.row.id, (data) => {
                                getResults()
                            });
                        }}>
                        <DeleteIcon/>
                    </IconButton>,

                    <IconButton
                        sx={{mr: 1}}
                        disabled={!vis}
                        onClick={() => {
                            setView(value.row.id)
                        }}>
                        <VisibilityIcon/>
                    </IconButton>,
                    getStatus(value.row.id, e[0].stepName)
                ]
            }
        },
        {
            field: 'loc', headerName: 'Tile',
            width: 150,
            valueGetter: (value, row) => {
                return row.tile.name.split("_")[0] + " (" + row.tile.params + ")"
            }
        },
        {
            field: 'date',
            headerName: 'Date Range',
            valueGetter: (value, row) => {
                return row.periodMin + " - " + row.periodMax
            }
        },
        {
            field: 'method',
            headerName: 'Method',
            width: 300,
            valueGetter: (value, row) => {

                return row.method.name + " (" + row.method.lengthMin + " - " + row.method.lengthMax + " ), th: " + row.method.threshold + ")"
            }
        }
        ,
        {
            field: 'worker',
            headerName: <DeveloperBoardIcon/>,
            width: 60,
            valueGetter: (value, row) => {
                return row.method.workers
            }
        },
        {
            field: 'time',
            headerName: <AccessTimeIcon/>,
            width: 150,
            valueGetter: (value, row) => {
                let initEvent = null;
                let endEvent = null;
                row.events.forEach((e) => {
                    if (e.stepName === "init") {
                        if (initEvent === null) {
                            initEvent = e;
                        } else {
                            if (initEvent.time < e.time) {
                                initEvent = e;
                            }
                        }
                    }
                    if (e.stepName === "done" || e.stepName === "end") {
                        if (endEvent === null) {
                            endEvent = e;
                        } else {
                            if (endEvent.time < e.time) {
                                endEvent = e;
                            }
                        }
                    }

                });


                if (initEvent && endEvent && endEvent.time > initEvent.time) {
                    return  msToTime(endEvent.time - initEvent.time);
                }else {
                    return " - "
                }

            }
        }
    ];


    function getPageSize(height) {

        if (height > 650) {
            return 15;
        }
        return 5
    }

    const paginationModel = {page: 0, pageSize: getPageSize(height)};

    const [elements, setElements] = React.useState({});
    const [region, setRegion] = React.useState(null);
    const [parameter, setParameter] = React.useState(null);
    const [tile, setTile] = React.useState(null);
    const [periodMin, setPeriodMin] = React.useState(null);
    const [periodMax, setPeriodMax] = React.useState(null);
    const [method, setMethod] = React.useState(null);

    const [open, setOpen] = React.useState(false);


    React.useEffect(() => {
        if (Object.keys(elements).length > 0) {
            const param = Object.keys(elements)[0];
            setParameter(param);

        }
    }, [elements])

    React.useEffect(() => {
        if (parameter) {
            const region = Object.keys(elements[parameter])[0];
            setRegion(region);
        }
    }, [parameter])

    React.useEffect(() => {
        if (parameter && region) {
            const tile = elements[parameter][region][0];


            let listOfDate = [];
            for (let i = tile.date.min; i <= tile.date.max; i++) {
                listOfDate.push(i);
            }
            setListOfDate(listOfDate)

            setPeriodMin(tile.date.min)
            setPeriodMax(tile.date.max)
            setTile(0)
        }
    }, [parameter, region])


    function getResults() {
        ApiCtrl.getListOfResults((data) => {
            let res = [];
            Object.keys(data).forEach((d, key) => {
                data[d].id = d;
                res.push(data[d])
            });
            setListOfQuery(res)
        })
    }

    function getTiles() {
        ApiCtrl.getTiles((data) => {
            setTiles(data);
            let elements = {}
            data.forEach(d => {
                let name = d.name.split("_")[0]
                if (!elements[d.params]) {
                    elements[d.params] = {}
                }
                if (!elements[d.params][name]) {
                    elements[d.params][name] = []
                }
                elements[d.params][name].push(d);
            })
            setElements(elements);
            let tiles = {};
            data.forEach(d => {
                if (!tiles[d.location]) {
                    tiles[d.location] = [];
                }
                tiles[d.location].push(d);
            });
            setListOfRegions(Object.keys(tiles))

        });
    }

    React.useEffect(() => {
        setInterval(getResults, 10000);
        getResults()

        ApiCtrl.getMethods((data) => {
            setListOfMethods(data);

        });
        getTiles()
    }, []);


    React.useEffect(() => {
        if (region && listOfRegions && parameter && listOfDate) {
            setLoading(false);
        }
    }, [region, listOfRegions, parameter, listOfDate]);


    React.useEffect(() => {
        if (listOfMethods) {
            setMethod(listOfMethods[0].name)
        }
    }, [listOfMethods])

    React.useEffect(() => {
        if (method) {
            let res = listOfMethods.find((d) => {
                return d.name === method
            });
            setMaxLength(res.lengthMax)
            setMinLength(res.lengthMin)
            setLength([14, res.lengthMax])
            setMaxThreshold(res.thresholdMax)
            setMinThreshold(res.thresholdMin)
            setMaxNbWorker(res.workers)
            setNbWorker(res.workers)
        }
    }, [method])


    if (loading) {
        return (<Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'column',
                alignItems: 'center'
            }}
        >
            <CircularProgress/>
        </Box>)
    }

    function getStatus(query, stepName) {
        if (stepName === "kill") {
            return (<IconButton

                onClick={() => {
                    ApiCtrl.reStartSimulation(query, (data) => {
                        getResults()
                    });
                }}
            >
                <SmsFailedIcon/>
            </IconButton>);
        } else if (stepName === "done" || stepName === "end") {
            return (<IconButton
                onClick={() => {
                    ApiCtrl.reStartSimulation(query, (data) => {
                        getResults()
                    });
                }}
            >
                <DoneIcon/>
            </IconButton>);
        } else if (stepName === "start") {

            return (<IconButton
                onClick={() => {
                    ApiCtrl.stopSimulation(query, (data) => {
                        getResults()
                    });
                }}>
                <CircularProgress size={25}/>
            </IconButton>);
        } else {
            return (
                <IconButton
                    onClick={() => {
                        ApiCtrl.reStartSimulation(query, (data) => {
                            getResults()
                        });
                    }}
                >
                    <HourglassEmptyIcon/>
                </IconButton>
            );
        }

    }


    function msToTime(duration) {

        let
            seconds = Math.floor((duration) % 60),
            minutes = Math.floor((duration / (60)) % 60),
            hours = Math.floor((duration / (60 * 60)) % 24);

        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;

        return hours + ":" + minutes + ":" + seconds;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: "flex-start",
                mt: 5
            }}
        >
            <Box sx={{width: "500px", display: "flex", m: 5, mt: 2, flexWrap: "wrap"}}>
                <Box sx={{width: "100%"}}>
                    {parameter && <Box sx={{
                        width: "100%",
                        display: "flex",
                        mt: 1,
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "24%"}}>Variable</Typography>
                        <Select
                            size="small"
                            sx={{width: "75%"}}
                            value={parameter}
                            onChange={(event) => setParameter(event.target.value)}
                        >
                            {Object.keys(elements).map((param, key) => {
                                return (<MenuItem key={key} value={param}>{param}</MenuItem>)
                            })}
                        </Select>
                    </Box>}
                    {parameter && <Box sx={{
                        width: "100%",
                        display: "flex",
                        mt: 1,
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "24%"}}>Region</Typography>
                        <Select
                            size="small"
                            sx={{width: "75%"}}
                            value={region}
                            onChange={(event) => setRegion(event.target.value)}
                        >
                            {Object.keys(elements[parameter]).map((param, key) => {
                                return (<MenuItem key={key} value={param}>{param}</MenuItem>)
                            })}
                        </Select>
                    </Box>}
                    {parameter && region && <Box sx={{
                        width: "100%",
                        display: "flex",
                        mt: 1,
                        alignItems: "center",
                        justifyContent: "space-between"
                    }}>
                        <Typography sx={{width: "24%"}}>Tile name</Typography>
                        <Select
                            size="small"
                            sx={{width: "75%"}}
                            value={tile}
                            onChange={(event) => setTile(event.target.value)}
                        >
                            {Object.keys(elements[parameter][region])
                                .sort((a, b) => {
                                    return elements[parameter][region][a].name.localeCompare(elements[parameter][region][b].name)
                                })
                                .map((param, key) => {
                                    return (
                                        <MenuItem
                                            key={key}
                                            value={key}>{elements[parameter][region][param].name}
                                        </MenuItem>)
                                })}
                        </Select>
                    </Box>}

                    {listOfDate && periodMin && periodMax &&
                        <Box sx={{
                            width: "100%",
                            display: "flex",
                            mt: 1,
                            alignItems: "center",
                            justifyContent: "space-between"
                        }}>
                            <Typography sx={{width: "24%"}}>Date range</Typography>
                            {periodMin && <Select
                                size="small"
                                sx={{width: "37%"}}
                                value={periodMin}
                                onChange={(event) => setPeriodMin(event.target.value)}
                            >
                                {listOfDate.map((d, key) => {
                                    return (<MenuItem key={key} value={d}>{d}</MenuItem>)
                                })}
                            </Select>}
                            {periodMax && <Select
                                size="small"
                                sx={{width: "37%"}}
                                value={periodMax}
                                onChange={(event) => setPeriodMax(event.target.value)}
                            >
                                {listOfDate.map((d, key) => {
                                    if (d <= periodMin) return null;
                                    return (<MenuItem key={key} value={d}>{d}</MenuItem>)
                                })}
                            </Select>}
                        </Box>}
                    <Box sx={{width: "100%", height: 300, display: "flex", mt: 1, alignItems: "center"}}>
                        {tile !== null && elements[parameter][region][tile] &&
                            <MapBlaster tile={elements[parameter][region][tile]}/>}
                    </Box>
                </Box>
                <Box sx={{width: "100%"}}>
                    <Box sx={{width: "100%", display: "flex", mt: 1, alignItems: "center"}}>
                        <Typography sx={{width: "24%"}}>Threshold</Typography>
                        <Slider
                            size="small"
                            sx={{width: "75%"}}
                            valueLabelDisplay="auto"
                            min={minThreshold}
                            step={0.1}
                            max={maxThreshold}
                            value={threshold} onChange={(e) => {
                            setThreshold(e.target.value)
                        }}/>
                    </Box>
                    <Box sx={{width: "100%", display: "flex", mt: 1, alignItems: "center"}}>
                        <Typography sx={{width: "24%"}}>Length</Typography>
                        <Slider
                            size="small"
                            sx={{width: "75%"}}
                            valueLabelDisplay="auto"
                            min={minLength}
                            max={maxLength}
                            value={length} onChange={(e) => {
                            setLength(e.target.value)
                        }}/>
                    </Box>
                </Box>
                <Box sx={{width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <Button
                        disabled={!region || !parameter || !periodMin || !periodMax || !method}
                        variant={"contained"}
                        color={"success"}
                        sx={{width: "49%"}}
                        onClick={() => {

                            let res = listOfMethods.find((d) => {
                                return d.name === method
                            });

                            let restTile = tiles.find((d) => {
                                if (d.name && d.params) {
                                    if (d.name.includes(region) && d.params === parameter) {
                                        return true
                                    }
                                    console.log(d)
                                }
                                return false
                            })


                            console.log(res)
                            console.log(restTile)

                                                        ApiCtrl.startSimulation({
                                                            "periodMin": periodMin,
                                                            "periodMax": periodMax,
                                                            "tile": {
                                                                "location": restTile.location,
                                                                "name": restTile.name,
                                                                "path": restTile.path,
                                                                "params": restTile.params
                                                            },
                                                            "method": {
                                                                "name": method,
                                                                "path": res.path,
                                                                "lengthMin": length[0],
                                                                "lengthMax": length[1],
                                                                "threshold": threshold,
                                                                "workers": nbWorker
                                                            }
                                                        }, (data) => {
                                                            getResults()
                                                        });
                        }}
                    >
                        Launch
                    </Button>
                    <Button
                        disabled={!region || !parameter || !periodMin || !periodMax || !method}
                        variant={"contained"}
                        sx={{width: "49%"}}
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        Upload a dataset
                    </Button>
                </Box>

            </Box>
            <Box sx={{width: "calc(100% - 620px)", height: "100%", display: "flex", m: 2, flexWrap: "wrap"}}>
                <DataGrid
                    rows={listOfQuery}
                    columns={columns}
                    initialState={{pagination: {paginationModel}}}
                    pageSizeOptions={[5, 10, 15, 20]}
                    disableRowSelectionOnClick
                    sx={{border: 0}}
                />

            </Box>
            <UploadDialog
                open={open}
                setOpen={() => {
                    getTiles();
                    setOpen();
                }}/>
        </Box>
    );
}

